import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { LocalStorage } from "@common/lib/storage/local-storage";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { CommonTeamsUiService } from "@org-common/lib/teams/common-teams-ui.service";
import { BehaviorSubject, filter } from "rxjs";

@Component({
    selector: "adapt-team-location-dashboard-element",
    templateUrl: "./team-location-dashboard-element.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TeamLocationDashboardElementComponent extends BaseComponent {
    private readonly showHierarchyContextKey = "showHierarchyContext";
    private readonly showHierarchyPeopleKey = "showHierarchyPeople";

    @Input()
    public set team(value: Team | undefined) {
        this.team$.next(value);
    }

    public team$ = new BehaviorSubject<Team | undefined>(undefined);
    public canEditTeam = false;

    public constructor(
        private teamsUiService: CommonTeamsUiService,
        teamsAuthService: CommonTeamsAuthService,
    ) {
        super();

        this.team$.pipe(
            filter((team) => !!team),
            this.takeUntilDestroyed(),
        ).subscribe((team) => this.canEditTeam = teamsAuthService.currentPersonCanEditTeam(team!));
    }

    public get showPeople() {
        return !!LocalStorage.get<boolean>(this.showHierarchyPeopleKey);
    }

    public set showPeople(value: boolean) {
        LocalStorage.set(this.showHierarchyPeopleKey, value);
    }

    public get showMoreContext() {
        return !!LocalStorage.get<boolean>(this.showHierarchyContextKey);
    }

    public set showMoreContext(value: boolean) {
        LocalStorage.set(this.showHierarchyContextKey, value);
    }

    public editLocation(team?: Team) {
        if (team) {
            return this.teamsUiService.editTeamLocations(team).subscribe();
        }
    }
}
